<script>
    
    import { createEventDispatcher } from 'svelte';

    import Pincelate from 'pincelatejs';
    import { pin } from './pincelate-store.js';
    import LoadingPincelate from './util/LoadingPincelate.svelte';

    import active from 'svelte-spa-router/active'

    import Modal from './util/Modal.svelte';

    let pinPromise = new Promise((resolve) => resolve());

    // load pincelate when necessary
    if ($pin === undefined) {
        $pin = new Pincelate("/assets/");
        if (!$pin.modelReady) {
            pinPromise = $pin.init();
        }
    }

    let showModal = false;

    const dispatch = createEventDispatcher();

    function reset() {
        dispatch('reset');
    }

</script>

<style>
    .widget-box {
        max-width: 60rem;
        display: grid;
        margin: 0 auto;
    }

    /* mobile */
    @media screen and (max-width: 39.999em) {
        .leftside {
            flex-direction: row-reverse;
            align-items: flex-end;
            justify-content: space-evenly;
            top: 0.3rem; /* slide under to compensate for inset border */
        }
        .rightside {
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-evenly;
            top: -0.3rem;
        }
        .rightside.only-one {
            justify-content: flex-start;
            padding-left: 2.5rem;
        }
        .nav {
            flex-direction: row;
            border-radius: 1.5rem 1.5rem 0 0;
            margin-bottom: 0;
        }
        .left-tab {
            border-radius: 1.5rem 1.5rem 0 0;
            padding: 0.75rem;
            padding-bottom: 1rem !important;
        }
        .right-tab {
            border-radius: 0 0 1.5rem 1.5rem;
            border-top: none;
            padding: 0.75rem;
        }
        .nav li {
            padding: 0.75rem 0.35rem 1rem 0.35rem;
            border-radius: 1.5rem 1.5rem 0 0 ;
        }
        .nav li a {
            margin: 0 0.3rem 0 0.3rem;
        }
        .nav :global(li.active) {
            border-radius: 1.5rem 1.5rem 0 0;
            border-bottom: 0;
        }
        :global(.component) {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }

    }

    /* full width */
    @media screen and (min-width: 40rem) {
        .widget-box {
            grid-template-columns: 1fr 7fr 1fr;
        }
        .leftside {
            left: 1rem; /* slide under to compensate for inset border */
            flex-direction: column;
            justify-content: space-between;
        }
        .rightside {
            flex-direction: column;
            left: -1rem;
        }
        .nav {
            flex-direction: column;
            margin-top: 1.75rem;
            border-radius: 1.5rem 0 0 1.5rem;
        }
        .left-tab {
            border-radius: 1.5rem 0 0 1.5rem;
            margin-bottom: 1.75rem;
            padding: 0.75rem;
        }
        .right-tab {
            border-radius: 0 1.5rem 1.5rem 0;
            border-top: none;
            padding: 0.75rem;
            margin-top: 1.75em;
            margin-bottom: 1.75em;
        }
        .nav li {
            padding: 0.35rem 0 0.35rem 0.75rem;
            border-radius: 1.5rem 0 0 1.5rem;
        }
        .nav li a {
            margin: 0.3rem 0 0.3rem 0;
        }
        .nav :global(li.active) {
            border-radius: 1.5rem 0 0 1.5rem;
            border-right: 0;
        }
    }

    .nav {
        list-style: none;
        display: flex;
        padding: 0;
        position: relative;
        box-shadow: inset 0 0 0 0.10rem black; /* inset border */
        border: none;
    }

    .nav li a {
        display: block;
        width: 2.5rem;
        height: 2.5rem;
        background-size: 100%;
    	background-origin: border-box;
        transition: transform 125ms ease-out;
    }

    .nav li a:hover {
        text-decoration: none;
        transform: scale(1.2);
    }

    .nav li {
        border: 0.15rem transparent solid;
    }

    .nav :global(li.active) {
        border: 0.15rem black solid;
        
        background-color: #ddd;
    }

    .right-tab {
        box-shadow: inset 0 0 0 0.10rem black;
        border: none;
        position: relative;
    }

    .rightside {
        display: flex;
        
        position: relative;
    }

    .leftside {
        display: flex;
        position: relative;
    }

    .left-tab {
        box-shadow: inset 0 0 0 0.10rem black;
        border: none;
        position: relative;
    }

    .tagline {
        font-size: 0.75rem;
        text-transform: uppercase;
        margin-top: 0rem;
        text-align: right;
        width: 50%;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }

    .header h3 {
        letter-spacing: 0.05em;
    }

    .tab-link {
        font-size: 0.75rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-transform: uppercase;
        color: black;
    }

    .tab-link:hover {
        text-decoration: none;
    }

</style>

{#await pinPromise}
    <LoadingPincelate />
{:then}

    <div class="widget-box">
        <div class="leftside">
            <div>
                <ul class="nav light">
                    <li use:active={"/mixer"}>
                        <a title="Mixer"
                        style="background-image: url(/assets/svg/_menu-large-blue.svg"
                        href="#/mixer">&nbsp;</a>
                    </li>
                    <li use:active={"/mouthfeel"}>
                        <a title="Mouthfeel Modulator"
                        style="background-image: url(/assets/svg/_menu-large-cyan.svg"
                        href="#/mouthfeel">&nbsp;</a>
                    </li>
                    <li use:active={"/respeller"}>
                        <a title="Respeller"
                        style="background-image: url(/assets/svg/_menu-large-orange.svg"
                        href="#/respeller">&nbsp;</a>
                    </li>
                    <li use:active={"/sequencer"}>
                        <a title="Sequencer"
                        style="background-image: url(/assets/svg/_menu-large-red.svg"
                        href="#/sequencer">&nbsp;</a>
                    </li>
                    <li use:active={"/explorer"}>
                        <a title="Explorer"
                        style="background-image: url(/assets/svg/_menu-large-purple.svg"
                        href="#/explorer">&nbsp;</a>
                    </li>
                </ul>
            </div>
            <div>
                <div class="left-tab light">
                    <a href="#/" title="Home" class="tab-link">
                        <div style="background-image: url(/assets/svg/_menu-medium-home.svg);
                            width: 1.5rem; height: 1.5rem; background-size: 100%;" class="hovery">&nbsp;</div>
                        <div>Home</div>
                    </a>
                </div>
            </div>
        </div>

        <div style="z-index: 1;" class="component box light lev0">

            <div class="header">
                <h3><slot name="title"></slot></h3>
                <div class="tagline"><slot name="tagline"></slot></div>
            </div>
    
            <slot name="widget" pin={$pin}></slot>

        </div>
        <div class="rightside" class:only-one={!$$slots.sidetab}>
            <div class="right-tab light">
                <div class="control-pair">
                    <button class="hovery" style="background-image: url(/assets/svg/_menu-medium-help.svg);"
                        id="help" title="Help"
                        on:click="{() => showModal = true}">&nbsp;</button>
                    <label for="help">Help</label>
                </div>
                <div class="control-pair">
                    <button class="hovery" style="background-image: url(/assets/svg/_minus-medium-black.svg);"
                        id="reset" title="Reset"
                        on:click={reset}>&nbsp;</button>
                    <label for="reset">Reset</label>
                </div>
            </div>
            {#if $$slots.sidetab}
            <div class="right-tab dark">
                <slot name="sidetab"></slot>
            </div>
            {/if}
        </div>
    </div>

{:catch error}
    <p>error: {error}</p>
{/await}

{#if showModal}
	<Modal on:close="{() => showModal = false}">
		<slot name="modalContent">help!</slot>
	</Modal>
{/if}